module.exports = __webpack_public_path__ + "img/square-trash.e84d5943.svg";